// Import the functions needed from the Firebase SDKs
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getPerformance } from 'firebase/performance'

const firebaseConfig = {
  apiKey: 'AIzaSyDykgkpUJHCiWQj0gVW_yTBIUGLja0eD64',
  authDomain: 'prioritize-836aa.firebaseapp.com',
  projectId: 'prioritize-836aa',
  storageBucket: 'prioritize-836aa.appspot.com',
  messagingSenderId: '582699375462',
  appId: '1:582699375462:web:3a5e24566c883a5ad406a7',
  measurementId: 'G-VD7DPEDFJE'
}

const devFirebaseConfig = {
  apiKey: 'AIzaSyCVigIYI8MdkTkf5fFXtNQizyv__pfOaLY',
  authDomain: 'syft-dev.firebaseapp.com',
  projectId: 'syft-dev',
  storageBucket: 'syft-dev.appspot.com',
  messagingSenderId: '81504291986',
  appId: '1:81504291986:web:2c76ea59a0b835727c2a4b',
  measurementId: 'G-PEQCJNJ3S1'
}

// Initialize Firebase
const firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp()
let activeFirebaseApp = firebaseApp

// Determine which Firebase app to use (production or development)

const productionEnvironments = ['syft-production', 'syft-beta']

if (!productionEnvironments.includes(import.meta.env.VITE_TARGET_ENVIRONMENT)) {
  const devFirebaseApp = initializeApp(devFirebaseConfig, 'dev')
  activeFirebaseApp = devFirebaseApp
} else {
  getPerformance(firebaseApp) // track get performance in prod only
}

let auth = getAuth(activeFirebaseApp)
let db = getFirestore(activeFirebaseApp)

const comments_version = 'comments_v3'
const filters_version = 'filters_v1'
const master_accounts_version = 'master_accounts_v1'
const master_hits_version = 'master_hits_v3'
const workspaces_version = 'workspaces_v1'
const lists_version = 'lists_v2'
const value_hypothesis_version = 'value_hypothesis_v1'
const value_matches_version = 'value_matches_v4'
const flows_version = 'flows_v1'
const prospect_qualification_signals_version = 'prospect_qualification_signals_v1'

export {
  activeFirebaseApp,
  auth,
  db,
  comments_version,
  filters_version,
  lists_version,
  master_accounts_version,
  master_hits_version,
  workspaces_version,
  value_hypothesis_version,
  value_matches_version,
  flows_version,
  prospect_qualification_signals_version
}
